import { memo } from "react";
import { Route, Routes } from "react-router-dom";

import { Genders } from "@/types/gender";
import { FlowTypes } from "@/utils/providers/types";

import ChooseGender from "./components/ChooseGender";
import { lazyWithPreload } from "./utils/lazyPreload";

const MaleFlow = lazyWithPreload(() => import("./male/MaleFlow"));
const FemaleFlow = lazyWithPreload(() => import("./female/FemaleFlow"));

const OfferFlow = () => (
    <Routes>
        <Route path="*" element={<ChooseGender />} />
        <Route path={Genders.Male} element={<MaleFlow flowType={FlowTypes.Offer} />} />
        <Route path={Genders.Female} element={<FemaleFlow flowType={FlowTypes.Offer} />} />
    </Routes>
);

export default memo(OfferFlow);
